import { toast } from './toast';

/** Copies text with the async Clipboard API, falling back to a hidden textarea (older browsers, http). */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      ta.remove();
      return ok;
    } catch {
      return false;
    }
  }
}

export async function copyWithToast(text: string): Promise<void> {
  if (await copyText(text)) toast('success', `Copied ${text}`);
  else toast('error', 'Could not copy to the clipboard');
}
